import React from "react";
import {isArray} from "lodash";

class GetViewOffset extends React.Component {
    constructor(props) {
        super(props);
        this.references = props.references;

        this.containerRef = React.createRef();
        this.state = {state: {}};
    }

    componentDidMount() {
        this.handleResize = () => this.update();
        this.handleScroll = () => this.update();

        this.update();

        window.addEventListener("resize", this.handleResize,  {passive: true});
        window.addEventListener("scroll", this.handleScroll, {passive: true});
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener("scroll", this.handleScroll);
    }

    getOffset(reference, container) {
        let ref = container;
        let pos;
        if (isArray(reference)) {
            ref = document.querySelector(reference[0])?.getBoundingClientRect();
            pos = reference[1];
        } else {
            pos = reference;
        }

        if (!ref || !pos) {
            return 0;
        }

        switch (pos) {
            case 'top':
                return ref.top;
            case 'right':
                return ref.left + ref.width;
            case 'bottom':
                return ref.top + ref.height;
            case 'left':
                return ref.left;
        }
    }

    update () {
        if (!this.containerRef) return false
        const container = this.containerRef.current.getBoundingClientRect();

        const res = {};

        for (const referencesKey in this.references) {
            const from = this.references[referencesKey][0];
            const to = this.references[referencesKey][1];

            res[referencesKey] = this.getOffset(to, container) - this.getOffset(from, container);
        }

        if (this.props.cb) {
            this.props.cb(res);
        }
    }

    render() {
        return <div ref={this.containerRef}>{this.props.children}</div>
    }
}

export default GetViewOffset;